import {
  PostHistoryRequestBodyType,
  PostHistoryResponseBodyType,
} from "@intelligems/ig-types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";
import { historyKeys } from "../queryKeys";

const postHistory = async (payload: PostHistoryRequestBodyType) => {
  const resp = await api.post<PostHistoryResponseBodyType>(
    `/v2/experiences/{experienceId}/history`,
    payload
  );
  return resp.data;
};

export const usePostHistory = () => {
  const queryClient = useQueryClient();
  return useMutation<
    PostHistoryResponseBodyType,
    Error,
    PostHistoryRequestBodyType,
    any
  >({
    mutationKey: ["postHistory"],
    mutationFn: async (payload: PostHistoryRequestBodyType) =>
      postHistory(payload),
    onSuccess: async (data, payload) => {
      await queryClient.invalidateQueries({
        queryKey: historyKeys.one(payload.experienceId),
      });
    },
  });
};
